/**
 * Estados de loading/empty/erro compartilhados pelas sub-tabs do Controle PLD
 * (Task #190 Fase 2). Empty orienta a importar o XLSX (#190 sub-fase 1).
 */
interface MsgProps {
  testId?: string;
}

export function PldLoading({ testId }: MsgProps) {
  return (
    <div
      className="text-white/40 text-sm py-12 text-center"
      data-testid={testId ?? "pld-loading"}
    >
      Carregando dados de PLD…
    </div>
  );
}

export function PldEmpty({ testId }: MsgProps) {
  return (
    <div
      className="rounded-2xl border border-white/10 bg-indra-azul-surface p-8 text-center"
      data-testid={testId ?? "pld-empty"}
    >
      <h3 className="text-white font-semibold mb-2">Sem dados de PLD para este mês</h3>
      <p className="text-white/60 text-sm">
        Verifique se o XLSX/CSV deste mês foi importado pela Mesa.
      </p>
      <p className="text-white/40 text-xs mt-2">
        Importação via <code className="text-indra-turquesa">POST /api/v2/pld/import</code>{" "}
        (CSV/XLSX do portal Dados Abertos CCEE).
      </p>
    </div>
  );
}

export function PldError({ testId }: MsgProps) {
  return (
    <div
      className="rounded-xl border border-indra-negativo/30 bg-indra-negativo/10 p-6 text-sm text-white/80"
      data-testid={testId ?? "pld-error"}
    >
      Não foi possível carregar os dados de PLD. Verifique a conexão e tente
      novamente.
    </div>
  );
}
